export default "__VITE_ASSET__DDWTefTH__"